<template>
<Dialog v-model="visible" :width="640" :max-width="1280" setting @setting="$emit('setting')">

  <template slot="title">
    <span class="title">{{ $t('type.SWITCH') }}</span>
  </template>

  <v-data-table :headers="headers" :items="items" :loading="loading" :footer-props="footers" :no-data-text="$t('history.no_data_available')" item-key="time" calculate-widths disable-sort>
    <template v-slot:item.on="{ item }">
      <span class="font-weight-bold" :class="getClass(item.on)">{{ $t(`switch.${item.on?'ON':'OFF'}`) }}</span>
    </template>
  </v-data-table>

</Dialog>
</template>

<script>
import Dialog from '@/components/utils/dialog/Dialog'
import HistoryDialog from '@/components/history/HistoryDialog'

export default {
  name: 'SwitchHistoryDialog',
  mixins: [HistoryDialog],
  components: {
    Dialog
  },
  computed: {
    headers() {
      return [{
        text: this.$t('history.time'),
        value: 'timeText',
      }, {
        text: this.$t('history.state'),
        value: 'on',
        align: 'center'
      }];
    }
  },
  methods: {
    getClass(state) {
      return state ? 'primary--text' : 'grey--text';
    }
  }
}
</script>
